export const countryList = {
  title: "List of Countries",
  line1:
    "The overall GDHM phases are listed below for each participating country. Country scores on indicators determine the overall phase of digital health for a country.",
  line2:
    "For a more detailed breakdown for each country, please visit the individual country page.",
  exportButtonText: "Export Data For All Countries",
};
